import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
import { useId } from "react";
/**
 * Can be sized by setting height only
 */
const SvgComponent = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => {
  // Dynamic mask id, sometimes required
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const id = useId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={undefined}
      height={18}
      fill="none"
      viewBox="0 0 18 18"
      aria-hidden="true"
      focusable="false"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M5 9.143c-.505 0-1.006.052-1.5.135v1.021a8 8 0 0 1 1.5-.156c.514 0 1.012.063 1.5.156V9.284A9 9 0 0 0 5 9.143m8 0c-.506 0-1.005.057-1.5.141v1.015a8 8 0 0 1 1.5-.156c.514 0 1.012.063 1.5.156V9.278a9 9 0 0 0-1.5-.135M5 6.5c-.514 0-1.012.062-1.5.15v1.016A7.5 7.5 0 0 1 5 7.5c.507 0 1.007.07 1.5.172V6.65A8.4 8.4 0 0 0 5 6.5m8 0a8.4 8.4 0 0 0-1.5.15v1.022A7.4 7.4 0 0 1 13 7.5a7.5 7.5 0 0 1 1.5.166V6.65A8.4 8.4 0 0 0 13 6.5M2 14.029V3.52a6.4 6.4 0 0 1 2.5-.509c1.212 0 2.4.346 3.438.999L8 4.049v10.3a10 10 0 0 0-3.5-.637 10 10 0 0 0-2.5.317m8 .32v-10.3l.062-.039a6.45 6.45 0 0 1 3.438-.999c.857 0 1.709.175 2.5.509v10.509a10 10 0 0 0-2.5-.317c-1.195 0-2.378.22-3.5.637M13.5 1A8.4 8.4 0 0 0 9 2.306a8.399 8.399 0 0 0-8.752-.15.51.51 0 0 0-.248.441v12.832a1 1 0 0 0 .991 1.005 1 1 0 0 0 .378-.077 8.1 8.1 0 0 1 3.131-.633c1.549 0 2.996.442 4.246 1.204a.49.49 0 0 0 .508 0 8.1 8.1 0 0 1 4.246-1.204c1.107 0 2.162.226 3.131.633a1 1 0 0 0 .378.077A1 1 0 0 0 18 15.429V2.597a.51.51 0 0 0-.248-.441A8.4 8.4 0 0 0 13.5 1"
        clipRule="evenodd"
      />
    </svg>
  );
};
const ForwardRef = forwardRef(SvgComponent);
const Memo = memo(ForwardRef);
export default Memo;
